// extracted by mini-css-extract-plugin
export default {"navigation_item":"LM1Cni0VdbV9NOMQEm_D","navigation_item__selected":"SvSCFg7WOynE9z2ZrzV0"};